// Module
var code = "<template> <div>Must override default template for Field subclasses</div> </template> ";
// Exports
export default code;